import React, { ReactElement } from 'react'
import LibDropDown from '@sport1/react-elements/DropDown'
import Grid from '@sport1/react-elements/Grid'
import Types from '@sport1/react-elements/Types'
import { DropDownProps } from './DropDownProps'
import ToggleDropDownIcon from './ToggleDropDownIcon'
import { dropDownContainerStyle, dropDownTextStyle } from './Styles'

const DropDown = <T,>({
    width = '100%',
    selectedOption,
    options,
    onOptionChange,
    onDismiss,
    onOpen,
    type = 'DEFAULT',
    testID,
}: DropDownProps<T>): ReactElement => {
    return (
        <LibDropDown
            testID={testID}
            selectedOption={selectedOption}
            options={options}
            onOptionChange={onOptionChange}
            onDismiss={onDismiss}
            onOpen={onOpen}
            renderDropDownIcon={(open: boolean): ReactElement => (
                <Grid alignRight noExpand>
                    <ToggleDropDownIcon type={type} open={open} />
                </Grid>
            )}
            dropDownContainerStyle={{
                width,
                ...dropDownContainerStyle[type],
            }}
            dropDownTextStyle={dropDownTextStyle[type]}
            optionContainerStyle={{
                width,
                backgroundColor: 'pearl',
                maxHeight: 202,
                marginTop: 1,
                border: 1,
                borderColor: 'moon-3',
                borderRadius: 3,
            }}
            optionStyle={({ hover }: { hover?: boolean }): Types.GridProps => ({
                backgroundColor: hover ? 'moon-3' : 'pearl',
                padding: 4,
            })}
            optionTextStyle={({ hover }): Types.DropDownTextStyle => ({
                lineHeight: '20px',
                fontSize: 14,
                color: hover ? 'BLACK' : 'onyx',
                numberOfLines: 1,
            })}
        />
    )
}

export default DropDown
